export default "__VITE_ASSET__CQCBKLi3__"